/*
 * Copyright (c) 2020. American Express Company
 */

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import React, { Component, ReactComponentElement } from 'react';

import { IconDollar, IconHide, IconTransfer } from '@americanexpress/dls-react';
import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import './OccurrenceMenu.scss';

export default class OccurrenceMenu extends Component<any> {
    public override render(): ReactComponentElement<any> {
        return (
            <Menu
                key="occurrence-menu"
                anchorEl={this.props.anchorEl}
                keepMounted
                open={Boolean(this.props.anchorEl)}
                onClose={this.props.onDismiss}
                className="occurrence-menu"
            >
                <MenuItem className="menu-item" dense={false} onClick={() => this.props.onSelect('typical')}>
                    <Typography variant={TypographyVariants.SUBTEXT_BOLD} className="occurrence">
                        <IconTransfer filled />
                        Typical
                    </Typography>
                    <Typography variant={TypographyVariants.LEGAL_PRIMARY} className="help">
                        {this.props.type === 'income'
                            ? 'We will calculate future income in this category using this transaction amount.'
                            : 'We will calculate future spending in this category using this transaction amount.'}
                    </Typography>
                </MenuItem>
                <MenuItem className="menu-item" dense={false} onClick={() => this.props.onSelect('one-time')}>
                    <Typography variant={TypographyVariants.SUBTEXT_BOLD} className="occurrence">
                        <IconDollar filled />
                        One-Time
                    </Typography>
                    <Typography variant={TypographyVariants.LEGAL_PRIMARY} className="help">
                        {this.props.type === 'income'
                            ? 'We will not calculate future income in this category using this transaction amount.'
                            : 'We will not calculate future spending in this category using this transaction amount.'}
                    </Typography>
                </MenuItem>
                <MenuItem className="menu-item" dense={false} onClick={() => this.props.onSelect('ignore')}>
                    <Typography variant={TypographyVariants.SUBTEXT_BOLD} className="occurrence">
                        <IconHide filled />
                        Ignore
                    </Typography>
                    <Typography variant={TypographyVariants.LEGAL_PRIMARY} className="help">
                        We will ignore this transaction.
                    </Typography>
                </MenuItem>
            </Menu>
        );
    }
}
